"use strict";

// Incident lifecycle: open -> completed -> confirmed. Colours match the mobile
// app (Open = orange, Completed = blue, Confirmed = green).
export const INCIDENT_STATUS = {
  open: { text: "Open", variant: "warning" },
  completed: { text: "Completed", variant: "primary" },
  confirmed: { text: "Confirmed", variant: "success" },
};

export const PATROL_STATUS = {
  safe: { text: "Aman", variant: "success" },
  finding: { text: "Ada Temuan", variant: "danger" },
};

export const STAR_LEVELS = [1, 2, 3, 4, 5];

const statusInfo = (map, value) =>
  map[value] || { text: value || "-", variant: "secondary" };

export const incidentStatus = (value) => statusInfo(INCIDENT_STATUS, value);

export const patrolStatus = (value) => statusInfo(PATROL_STATUS, value);

// Filter options for <search-select>; the null option clears the filter.
const toOptions = (map, allText) => [
  { value: null, text: allText },
  ...Object.entries(map).map(([value, { text }]) => ({ value, text })),
];

export const incidentStatusOptions = () =>
  toOptions(INCIDENT_STATUS, "Semua Status");

export const patrolStatusOptions = () =>
  toOptions(PATROL_STATUS, "Semua Status");

export const starLevelOptions = () => [
  { value: null, text: "Semua Level Bintang" },
  ...STAR_LEVELS.map((level) => ({ value: level, text: `${level} Bintang` })),
];

// Star level is null for reports made before the feature or from old app
// versions; those render as "-".
export const formatStarLevel = (level) => {
  const value = Number(level);
  if (!level || !STAR_LEVELS.includes(value)) return "-";
  return "★".repeat(value) + "☆".repeat(5 - value);
};

export const orDash = (value) =>
  value === null || value === undefined || value === "" ? "-" : value;
